// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5491b2ce","389":"d82eacbb","453":"64aababc","732":"1904eb03","977":"e80a7bd1"}[chunkId] + ".chunk.js";
};